import service from "services/maintenance/trainingService";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const loanTypeResource = {
    title: "Trainings",
    singular: "Training",
    displayField: "description",
    service: service,
    setter: MAINTENANCE_STORE_SELECTORS.TRAININGS,
    columns: [
        {
            field: "trainingCode",
            header: "Training Code",
            width: "15%"
        },
        {
            field: "description",
            header: "Training Description"
        },
        {
            field: "targetAttendee",
            header: "Target Attendee"
        },
        {
            field: "startDate",
            header: "schedule"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "10%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "10%"
        }
    ],
    fields: [
        {
            name: "trainingCode",
            label: "Training Code",
            type: "text",
            required: true,
            unique: true
        },
        {
            name: "description",
            label: "Training Description",
            type: "text",
            required: true
        },
        {
            name: "startDate",
            label: "Schedule",
            type: "date"
        },
        {
            name: "targetAttendee",
            label: "Target Attendee",
            type: "text"
        }
    ],
    searchFields: ["trainingCode", "description"]
};

export default loanTypeResource;
